/* eslint-disable no-param-reassign */
import format from 'date-fns/format';

export function getMilliSecondsTimestamp(timestamp) {
  if (typeof timestamp === 'undefined') {
    return '';
  }
  let milliTimestamp = timestamp;
  const timestampLen = timestamp.toString().length;
  const zerosToAdd = 13 - timestampLen;

  if (zerosToAdd > 0) {
    for (let i = 0; i < zerosToAdd; ) {
      milliTimestamp *= 10;
      i += 1;
    }
  }

  return milliTimestamp;
}
export function dateToStringWithFormat(timestamp, dateFormat) {
  if (timestamp && timestamp.indexOf && timestamp.indexOf('-') !== -1) {
    const nowDate = new Date(timestamp);
    timestamp = nowDate.getTime();
  }
  const validTimestamp = Number(getMilliSecondsTimestamp(timestamp));
  const date = new Date(validTimestamp);
  const timestamp2 =
    validTimestamp + date.getTimezoneOffset() * 60 * 1000 + 330 * 60 * 1000;
  const readableTime = format(timestamp2, dateFormat);
  if (readableTime === 'Invalid Date') return '';
  return readableTime;
}

export function getDaysRangeTimeStamp(day = 1) {
  if (typeof day === 'undefined') return undefined;
  const dt = new Date();
  const curdt = dt.setHours(23, 59, 59, 0);
  return {
    frm: curdt - 1000 * 60 * 60 * 24 * day + 1000,
    to: curdt,
  };
}

export function getMonthsRangeTimestamp(month = 1) {
  if (typeof month === 'undefined') return undefined;
  const dt = new Date();
  const curdt = dt.setHours(23, 59, 59, 0);
  return {
    frm: curdt - 1000 * 60 * 60 * 24 * 30 * month + 1000,
    to: curdt,
  };
}

export function getYearsRangeTimeStamp(year = 1) {
  if (typeof year === 'undefined') return undefined;
  const dt = new Date();
  const curdt = dt.setHours(23, 59, 59, 0);
  return {
    frm: curdt - 1000 * 60 * 60 * 24 * 365 * year + 1000,
    to: curdt,
  };
}

export function getDaysMiliseconds(day = 1) {
  return 1000 * 60 * 60 * 24 * day - 1000;
}

export function getMonthsMiliseconds(month = 1) {
  return 1000 * 60 * 60 * 24 * 30 * month - 1000;
}

export function getYearsMiliseconds(year = 1) {
  return 1000 * 60 * 60 * 24 * 365 * year - 1000;
}

export function dateToStringWithFormatTopic(timestamp, dateFormat) {
  if (timestamp && timestamp.indexOf && timestamp.indexOf('-') !== -1) {
    const nowDate = new Date(timestamp);
    timestamp = nowDate.getTime();
  }
  const validTimestamp = timestamp;
  const date = new Date(timestamp);
  const timestamp2 =
    validTimestamp + date.getTimezoneOffset() * 60 * 1000 + 330 * 60 * 1000;
  const readableTime = format(timestamp2, dateFormat);
  if (readableTime === 'Invalid Date') return '';
  return readableTime;
}

export function formatMinutesToHours(minutes) {
  if (!minutes) {
    return '';
  }
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;

  return `${hours > 0 ? `${hours} hr${hours > 1 ? 's' : ''} ` : ''}${
    mins > 0 ? `${mins} min${mins > 1 ? 's' : ''}` : ''
  }`.trim();
}

export const formatMillisecondsToDate = milliseconds => {
  if (!milliseconds) {
    return '';
  }
  const date = new Date(Number(milliseconds));
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  return `${day} ${month}, ${year}`;
};

export function convertTo12HourIST(input) {
  if (!input) {
    return input;
  }
  // Strip 'IST' and add GMT+0530 offset so Date can parse correctly
  const date = new Date(`${input.replace(' IST', '')} GMT+0530`);

  // Format options
  const options = {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZone: 'Asia/Kolkata',
  };

  // Format date
  let formatted = new Intl.DateTimeFormat('en-US', options).format(date);

  // Extract parts: e.g., "Nov 15, 2024, 3:35 PM"
  formatted = formatted.replace(
    /(\d{1,2}:\d{2})\s(AM|PM)/,
    (match, time, period) => `${time} ${period} IST`,
  );

  return formatted;
}

// Format: DD/MM/YYYY
export function getFormattedDate(input) {
  if (!input) {
    input = new Date();
  }
  const inputDate = new Date(input);
  return `${String(inputDate.getDate()).padStart(2, '0')}/${String(
    inputDate.getMonth() + 1,
  ).padStart(2, '0')}/${inputDate.getFullYear()}`;
}

export default {
  getMilliSecondsTimestamp,
  dateToStringWithFormat,
  getDaysRangeTimeStamp,
  getMonthsRangeTimestamp,
  getYearsRangeTimeStamp,
  getDaysMiliseconds,
  getMonthsMiliseconds,
  getYearsMiliseconds,
  formatMinutesToHours,
  formatMillisecondsToDate,
  convertTo12HourIST,
  getFormattedDate,
};
